export default import.meta.ROLLDOWN_FILE_URL_Omhq48VuhIW51vhz4rkajA